import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { InsightVariants, InsightWeights } from "./constants";
const { text, color } = ids || {};
const defaultStyle = css `
  color: ${color.text.heading.ids_color_text_heading_01};
`;
const highlight = css `
  color: ${color.text.highlight.ids_color_text_highlight};
`;
const onLight = css `
  color: ${color.contrast.ids_color_contrast_onLight};
`;
const onDark = css `
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const regular = { ...text.head.ids_textStyle_insight_regular };
const bold = { ...text.head.ids_textStyle_insight_bold };
const getInsightWeightStyle = (weight) => {
    switch (weight) {
        case InsightWeights.regular:
            return regular;
        case InsightWeights.bold:
            return bold;
        default:
            return regular;
    }
};
const getInsightVariantStyle = (variant, contrast) => {
    if (contrast === Contrast.dark)
        return onDark;
    if (contrast === Contrast.light)
        return onLight;
    switch (variant) {
        case InsightVariants.default: {
            return defaultStyle;
        }
        case InsightVariants.highlight:
            return highlight;
        default:
            return defaultStyle;
    }
};
const getPersonalizedStyle = (variant, weight) => {
    if (variant === InsightVariants.highlight && weight === InsightWeights.bold)
        return css `
      text-decoration: underline;
    `;
    return;
};
const StyledInsight = styled.div `
  ${({ weight }) => getInsightWeightStyle(weight)}
  ${({ variant, contrast }) => getInsightVariantStyle(variant, contrast)}
  ${({ variant, weight }) => getPersonalizedStyle(variant, weight)}
`;
export default StyledInsight;
//# sourceMappingURL=Insight.style.js.map